module.exports = function ToughCookie() {
    throw new TypeError('Cookie jars are only available on node');
};
//# sourceMappingURL=tough-cookie.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popsicle/dist/lib/browser/tough-cookie.js
// module id = 53
// module chunks = 0 1